export default "__VITE_ASSET__rGyAh9bW__"